<template>
  <i :class="`contact-method-icon contact-method-icon--${type}`"></i>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        required: true
      }
    }
  };
</script>

<style lang="scss">
  .contact-method-icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    border-radius: 3px;
    background-color: #b4e0fb;
    background-position: center;
    background-repeat: no-repeat;

    @each $type in 'work', 'office', 'home' {
      &--#{$type} {
        background-image: url('/img/icons/pbx/contact-methods/label/#{$type}.svg');
      }
    }
  }
</style>
